<template>
  <div class="gramophone-tab" :style="bgimg">
    <div class="tab-title">
      <img :src="title">
    </div>
    <div class="gramophone-toolbar">
      <Search
        class="gramophone-search"
        :filterList="searchFilter"
        @search="subminSearch"
        @offsearch="offSearch"
        gis
        :gisurl="gisurl"
      ></Search>
    </div>

    <div class="audio-wrapper">
      <swiper :options="swiperOption" ref="swiper">
        <swiper-slide v-for="(audio, index) in audios" :key="index">
          <div class="audio-title">
            <h3>{{audio.title}}</h3>
          </div>
          <AudioItem :audioData="audio" :class="lngClass"></AudioItem>
        </swiper-slide>
      </swiper>
      <div class="btn-audio-prev"></div>
      <div class="btn-audio-next"></div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

import Search from "@/components/Search.vue";
import AudioItem from "@/components/AudioItem.vue";
export default {
  props: {
    tabData: Object
  },
  components: {
    Search,
    AudioItem
  },
  data() {
    return {
      pageName: "audio-record",
      onSearch: false,
      searchFilter: [
        { name: "title", title: "名称" },
        { name: "perfomer", title: "演唱者" },
        { name: "publisher", title: "出版者" },
        { name: "region", title: "地区" },
        { name: "age", title: "年代" },
        { name: "album", title: "专辑" }
      ],
      swiperOption: {
        navigation: {
          nextEl: ".btn-audio-next",
          prevEl: ".btn-audio-prev"
        }
      },
      gisurl: "http://amap.zju.edu.cn/maps/3271/mobile?from=timeline&isappinstalled=0"
    };
  },
  computed: {
    ...mapState(["audio-record"]),
    ...mapGetters(["lngClass"]),
    title() {
      return this.tabData.ttimg;
    },
    bgimg() {
      const bgurl = this.tabData.bgimg;
      return { backgroundImage: `url("${bgurl}")` };
    },
    audios() {
      if (this.onSearch) {
        return this["audio-record"].searchres.content;
      }
      return this["audio-record"][0];
    }
  },
  mounted() {
    this.getPageData();
  },
  methods: {
    ...mapActions(["getAllDataList", "searchData"]),
    getPageData() {
      this.getAllDataList(this.pageName);
    },
    // chagenPage(num) {
    //   this.onSearch
    //     ? this.search(this.searchParam, num)
    //     : this.getPageData(num);
    //   this.$refs.dataList.scroll();
    // },
    search(param) {
      this.searchData({
        data_name: this.pageName,
        unpaged: true,
        ...param
      });
      this.searchParam = param;
      this.onSearch = true;
    },
    subminSearch(param) {
      this.search(param);
      this.$refs.swiper.update();
    },
    offSearch() {
      this.getPageData();
      this.onSearch = false;
      this.$refs.swiper.update();
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/base";
.gramophone-tab {
  position: relative;
  height: 100vh;
  background-size: cover;

  .tab-title {
    position: relative;
    top: 0.5rem;
    height: 5rem;
    margin-bottom: 1rem;
    overflow: hidden;

    img {
      position: relative;
      left: 50%;
      transform: translateX(-50%) scale(0.5);
      transform-origin: center top;
    }

    @media (max-width: 320px) {
      height: 4rem;
      img {
        transform: translateX(-50%) scale(0.4);
      }
    }
  }
}

.gramophone-toolbar {
  position: relative;
  z-index: 2;
  .gramophone-search {
    position: relative;
    @include center-x;
  }
}

.audio-wrapper {
  position: relative;
  .audio-title {
    margin-bottom: 1rem;
    text-align: center;

    @include title-h3(1rem);
    h3 {
      height: 1.2rem;
      line-height: 1.2;

      &::before,
      &::after {
        height: 1.2rem;
      }

      &::before {
        background-image: url("~@/assets/img/audio/title-left.png");
      }

      &::after {
        background-image: url("~@/assets/img/audio/title-right.png");
      }
    }
  }

  .swiper-container {
    overflow: visible;
  }

  .btn-audio-prev,
  .btn-audio-next {
    position: absolute;
    z-index: 10;
    top: 8rem;
    width: 2rem;
    height: 2rem;
    background-repeat: no-repeat;
    background-size: 100%;
    outline: none;
  }

  .btn-audio-prev {
    left: 0.5rem;
    background-image: url("~@/assets/img/audio/audio-prev.png");
  }

  .btn-audio-next {
    right: 0.5rem;
    background-image: url("~@/assets/img/audio/audio-next.png");
  }

  .swiper-button-disabled {
    opacity: 0.5;
  }

  .lng {
    &::after {
      display: none;
    }
  }
}
</style>
